/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { RiceError } from './RiceError';
import type { RiceIssuanceOccurrenceCountResult } from './RiceIssuanceOccurrenceCountResult';

export type RiceIssuanceResponse = {
    confirmationNumber?: string;
    contributingItemIds?: Array<string>;
    errors?: Array<RiceError>;
    issuanceOfferCode?: string;
    milesAmount?: number;
    offerDescription?: string;
    offerId?: string;
    processedDateTime?: string;
    status?: RiceIssuanceResponse.status;
    issuanceOccurrenceCountResult?: RiceIssuanceOccurrenceCountResult;
};

export namespace RiceIssuanceResponse {

    export enum status {
        CREATED = 'CREATED',
        PENDING = 'PENDING',
        CONFIRMED = 'CONFIRMED',
        REJECTED = 'REJECTED',
        HELD = 'HELD',
        MAX_RETRIES = 'MAX_RETRIES',
        ERROR = 'ERROR',
        RETURNS_NON_ISSUANCE = 'RETURNS_NON_ISSUANCE',
        BACKOUT = 'BACKOUT',
        BACKED_OUT = 'BACKED_OUT',
    }


}

